<template>
  <div :class="`m-mobile m-mobile-${routeType}-page mobile-${vlistClass}`">
    <div v-if="['whyc'].indexOf($route.params._field)>-1">
      <bs-list-yicuntype :filter="filter" :meta="{ module:'article-yicun-type',field:'list' }">
        <template slot="data" slot-scope="slot">
          <div class="type-wrap">
            <div style="overflow-x: scroll">
              <div class="box">
                <div class="box-item">类别选择:</div>
                <div
                  class="box-item"
                  v-bind:class="{'selected': selectedType==''}"
                  v-on:click="selectType({yicunType:''})"
                  style="min-width: 50px;"
                >不限</div>
                <div v-for="(item,index) in slot.data" :key="index">
                  <div
                    class="box-item"
                    v-if="item.yicunType&&item.yicunType!='其他遗存'"
                    v-bind:class="{'selected':selectedType  == item.yicunType}"
                    v-on:click="selectType(item)"
                  >{{item.yicunType}}</div>
                </div>
                <div
                  class="box-item"
                  v-bind:class="{'selected': selectedType=='其他遗存'}"
                  v-on:click="selectType({yicunType:'其他遗存'})"
                >其他遗存</div>
              </div>
            </div>
          </div>
        </template>
      </bs-list-yicuntype>
    </div>
    <div :class="`mobile-${vlistClass}-content`">
      <bs-page-scroll
        :filter="filter"
        :meta="meta"
        ref="refId"
        content-class
        @on-data-after="afterLoad"
      >
        <template slot="data" slot-scope="slot">
          <mobile-arti-page-video
            v-if="['zzsp', 'zg', 'whjt', 'song', 'zzsl','zzgs','whyc'].indexOf($route.params._field)>-1"
            :result="slot"
            :field="$route.params._field"
          ></mobile-arti-page-video>
          <mobile-merc-page
            v-else-if="['food','spot','720','vr','yjgl'].indexOf($route.params._field)>-1"
            :result="slot"
            :field="$route.params._field"
          ></mobile-merc-page>
          <mobile-arti-page-content v-else :result="slot" :field="$route.params._field"></mobile-arti-page-content>
        </template>
        <template slot="empty">
          <div class="nodata">
            <img src="../../assets/portal/zwsj.png" style="width: 100%;height: 100%;" />
          </div>
        </template>
        <template slot="paging">
          <div class="pdr" v-show="isShowLoadingMore" style="text-align:center">
            <div @click="loadMore()" :disabled="loadingDisabled">{{loadingText}}</div>
            <!-- <span @click="loadMore()" :disabled="loadingDisabled">{{loadingText}}</span> -->
          </div>
        </template>
      </bs-page-scroll>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedType: "",
      loadingDisabled: false,
      loadingText: "点击加载更多",
      titlearr: {
        zg: "朱子展馆",
        zzsl: "朱子四礼",
        song: "朱子之歌",
        bhjs: "保护建设",
        whjt: "朱子讲坛",
        zzsp: "朱子视频",
        whyc: "朱子遗存",
        zzgs: "朱子故事",
        yjcg: "研究成果",
        cjdz: "传纪大作",
        mwsh: "美文书画",
        spot: "景点",
        food: "美食",
        720: "全景浏览",
        vr: "全景视频",
        yjgl: "游记攻略"
      },
      routeType: "arti",
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        pageIndex: 1,
        pageSize: 10
      },
      api: null
    };
  },
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BsListYicuntype: () => import("../../components/bs-list-yicuntype"),
    MobileMercPage: () => import("./mobile-merc-page"),
    MobileArtiPageVideo: () => import("./mobile-arti-page-video"),
    MobileArtiPageContent: () => import("./mobile-arti-page-content"),
    BsPageScroll: () => import("../../components/bs-page-scroll"),
    mobileFooter: () => import("./mobile-footer")
  },
  computed: {
    isShowLoadingMore() {
      return this.$route.params._field === "zzgs"
        ? false
        : this.$route.params._field === "zzsl"
        ? false
        : true;
    },
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    },
    vlistClass() {
      if (
        ["zg", "whjt", "zzzg", "zzsl", "zzgs", "whyc"].indexOf(
          this.$route.params._field
        ) > -1
      ) {
        return "video";
      } else if (
        ["food", "spot", "720", "vr", "yjgl"].indexOf(
          this.$route.params._field
        ) > -1
      ) {
        return "merc";
      } else {
        return "articlelist";
      }
    }
  },
  methods: {
    selectType: function(item) {
      this.selectedType = item.yicunType;
      this.filter.yicunType = item.yicunType;
      this.$refs["refId"].loadData();
    },
    loadMore() {
      let that = this;
      that.filter.pageIndex += 1;
      this.$refs["refId"].loadData();
    },
    afterLoad(data) {
      let that = this;
      if (data.paging.totalPage === that.filter.pageIndex) {
        that.loadingText = "";
        that.loadingDisabled = true;
      } else {
        that.loadingText = "点击加载更多";
        that.loadingDisabled = false;
      }
    }
  },
  created() {
    this.$menuFn.setTitle(this.titlearr[this.$route.params._field]);
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "mobile-arti-page") {
        this.$menuFn.setTitle(this.titlearr[this.$route.params._field]);
      }
      if (from.name === "mobile-arti-main") {
        this.filter.yicunType = "";
        this.filter.selectedType = "";
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "page",
        "mobile"
      );
      if (this.routeWatch && contains) {
        this.$refs["refId"].clearData();
        this.filter.pageIndex = 1;
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>
<style lange="sass" scoped>
.selected {
  color: #921a1a;
}
.type-wrap {
  margin-right: 15px;
  margin-left: 15px;
}
.box {
  width: auto;
  min-width: 100%;
  display: flex;
}
.box-item {
  text-align: center;
  min-width: 80px;
  padding: 16px 0;
}
</style>